export const FETCH_PATIENTS_START = 'FETCH_PATIENTS_START';
export const FETCH_PATIENTS_SUCCESS = 'FETCH_PATIENTS_SUCCESS';

export const CREATE_PATIENT_CARD = 'CREATE_PATIENT_CARD';
export const RESET_PATIENT_CREATION = 'RESET_PATIENT_CREATION';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
